"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/** @jsx withSlots */
var Foundation_1 = require("../../Foundation");
var Utilities_1 = require("../../Utilities");
exports.TextView = function (props) {
    if (!props.children) {
        return null;
    }
    var block = props.block, className = props.className, _a = props.as, RootType = _a === void 0 ? 'span' : _a, variant = props.variant, nowrap = props.nowrap, rest = tslib_1.__rest(props, ["block", "className", "as", "variant", "nowrap"]);
    var Slots = Foundation_1.getSlots(props, {
        root: RootType
    });
    return Foundation_1.withSlots(Slots.root, tslib_1.__assign({}, Utilities_1.getNativeProps(rest, Utilities_1.htmlElementProperties)));
};
//# sourceMappingURL=Text.view.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Text/Text.view.js
// module id = 1222
// module chunks = 0